import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // baseURL: 'http://127.0.0.1:441/prophasud/portal/api/',
  // baseURL: '/pharmaconnect/',
  baseURL: 'https://myprophasud.com/pharmaconnect/',
})

Vue.prototype.$http = axiosIns

export default axiosIns
